var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMilestone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--grey-darken-33)",
  fillRule: "evenodd",
  d: "M3.468 12c0-4.992 4.126-9.04 9.214-9.04s9.214 4.048 9.214 9.04-4.126 9.04-9.214 9.04a9.26 9.26 0 0 1-6.511-2.652l1.454-1.426a7.18 7.18 0 0 0 5.057 2.069c3.962 0 7.166-3.144 7.166-7.031s-3.204-7.03-7.166-7.03S5.516 8.112 5.516 12h1.833c.456 0 .684.542.361.858L4.816 15.69a.52.52 0 0 1-.727-.003l-2.837-2.833c-.318-.317-.088-.854.365-.854zm10.248-1.758a1 1 0 0 1 .502.863v4.45h-1.536v-4.268l-3.583-2.09.737-1.215z",
  clipRule: "evenodd"
})));
export default SvgMilestone;